import { a as l } from "./chunk-BaseElement-CJM6sCUz.js";
import "./chunk-lit-element-D3OkYgeM.js";
import { e as i } from "./chunk-query-DDwcON_0.js";
var d = Object.defineProperty, h = (c, t, e, r) => {
  for (var s = void 0, n = c.length - 1, o; n >= 0; n--)
    (o = c[n]) && (s = o(t, e, s) || s);
  return s && d(t, e, s), s;
};
class a extends l {
  firstUpdated() {
    var t, e, r, s;
    (t = this.searchClose) == null || t.addEventListener("click", this.closeSearch.bind(this)), (e = this.search) == null || e.addEventListener("click", this.handleClick.bind(this)), (r = this.dialog) == null || r.addEventListener("click", this.handleDialogClick.bind(this)), (s = this.dialog) == null || s.addEventListener("close", () => {
      this.search.removeAttribute("open");
    });
  }
  handleDialogClick(t) {
    const e = this.dialog.getBoundingClientRect();
    e.top <= t.clientY && t.clientY <= e.top + e.height && e.left <= t.clientX && t.clientX <= e.left + e.width || this.closeSearch();
  }
  handleClick() {
    this.search.hasAttribute("open") || this.openSearch();
  }
  async openSearch() {
    var t;
    if (window.location.pathname === "/search") {
      const e = document.querySelector(
        'search-form input[type="search"]'
      );
      if (!e)
        return;
      e.focus(), e.setSelectionRange(0, e.value.length);
      return;
    }
    this.dialog.showModal(), this.searchWrap.classList.remove("animate-fadeOutSlideDown"), (t = this.searchWrap) == null || t.classList.add("animate-fadeInSlideUp"), this.searchInput && (this.searchInput.focus(), this.searchInput.setSelectionRange(0, this.searchInput.value.length), setTimeout(() => {
      this.searchInput.focus(), this.searchInput.setSelectionRange(0, this.searchInput.value.length);
    }, 200));
  }
  async closeSearch() {
    this.searchWrap.classList.remove("animate-fadeInSlideUp"), this.searchWrap.classList.add("animate-fadeOutSlideDown"), setTimeout(() => {
      this.dialog.close(), this.search.toggleAttribute("open");
    }, 200);
  }
}
h([
  i("[data-search-close]")
], a.prototype, "searchClose");
h([
  i("[data-search-input]")
], a.prototype, "searchInput");
h([
  i("[data-search-wrap]")
], a.prototype, "searchWrap");
h([
  i("[data-search]")
], a.prototype, "search");
h([
  i("dialog")
], a.prototype, "dialog");
customElements.define("search-component", a);
